import { analyticsEventEmitter } from '@wildberries/wb-front-analytics-tracker';

export const initAnalytics = () => {
  const counterId = Number(window.ENVS.WB_ANALYTICS_COUNTER_ID);

  analyticsEventEmitter.init({ counterId });
};
